import useKeyboard from './useKeyboard';
import { clearModal } from '../../../store/slices/modal.slice';
import { popFocus } from '../../../store/slices/focus.slice';
import { popRoute } from '../../../store/thunks/route.thunk';
import { useAppDispatch } from '../../../store/hooks';

interface Props {
  pop: boolean;
}

function useCloseModalKeyboard({ pop }: Props = { pop: false }) {
  const dispatch = useAppDispatch();
  useKeyboard({
    canBeFocused: false,
    keyDownHandler: () => null,
    keyUpHandler(key) {
      if (key === 'BACK') {
        if (pop) {
          dispatch(popRoute());
        } else {
          dispatch(popFocus());
          dispatch(clearModal());
        }
      }
    },
  });
}

export default useCloseModalKeyboard;
